var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81279 2.86794H6.96155V0.867173C6.76337 0.839909 6.08176 0.778564 5.28796 0.778564C3.63166 0.778564 2.49706 1.82037 2.49706 3.73515V5.49735H0.669312V7.73406H2.49706V13.362H4.73796V7.73458H6.49177L6.77018 5.49788H4.73743V3.95693C4.73796 3.31046 4.91203 2.86794 5.81279 2.86794Z",
    fill: "#9597AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b06cd031df373964b09aa5aebb6fc1c6.svg";
export { ForwardRef as ReactComponent };